import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './en/common.json';
import deCommon from './de/common.json';

export const defaultNS = 'common';
export const I18N_STORAGE_KEY = 'i18nextLng';
// Single source for every language picker; labels stay in their own language on purpose
export const LANGUAGE_OPTIONS = [
  { id: 'en', label: 'English' },
  { id: 'de', label: 'Deutsch' },
] as const;
export type LanguageId = (typeof LANGUAGE_OPTIONS)[number]['id'];
export const resources = {
  en: { common: enCommon },
  de: { common: deCommon },
} as const satisfies Record<LanguageId, unknown>;

// Registered before init() so the initial language is applied too
i18n.on('languageChanged', syncDocumentLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: LANGUAGE_OPTIONS.map((option) => option.id),
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export function getStoredAppLanguage(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(I18N_STORAGE_KEY);
}

export async function setAppLanguage(isoCode: string): Promise<void> {
  await i18n.changeLanguage(isoCode);
}

export default i18n;

// Keeps <html lang> on the real UI language, so Chrome only offers translation for languages the app does not ship
function syncDocumentLanguage(language: string) {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.lang = i18n.resolvedLanguage ?? language;
}
